import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { ModalContent, ModalHeader, Portal, Typography } from 'fronton-react';
import { Modal } from 'fronton-react/modal';
import {
  LemanaProLogoSimpleIcon,
  CheckSquareOffsetIcon,
  ArrowBendDoubleUpLeftIcon,
} from '@fronton/icons-react';
import { useTranslation } from 'react-i18next';
import { useBreakpoints } from 'common/hooks';
import {
  easyRefundAdvantage,
  easyRefundAdvantagesContainer,
  easyRefundAdvantageText,
  modalContainer,
  modalContent,
  modalCustom,
  refundInfoText,
} from './product-returns.styles';

type Props = {
  modalVisibility: boolean;
  setModalVisibility: Dispatch<SetStateAction<boolean>>;
};

export const ProductReturnsModal: React.FC<Props> = ({ modalVisibility, setModalVisibility }) => {
  const { t } = useTranslation();
  const { mobile, tablet, desktop, largeDesktop } = useBreakpoints() || {
    mobile: false,
    tablet: false,
    desktop: false,
    largeDesktop: false,
  };
  const modalSize = useMemo(() => {
    if (largeDesktop || desktop) return 'l';
    if (tablet) return 'm';
    if (mobile) return 's';
    return 'm';
  }, [desktop, largeDesktop, mobile, tablet]);
  const storeBrandName = 'Лемана\u00A0ПРО';

  return (
    <div
      className={modalContainer}
      data-qa="product-returns-new-modal"
      aria-label={t('product-returns.modal.title')}
    >
      <Portal>
        <Modal
          show={modalVisibility}
          modalID="product-returns-new"
          className={modalCustom}
          onClose={() => setModalVisibility(false)}
          size={modalSize}
          variant="curtain"
        >
          <ModalHeader title={t('product-returns.modal.title')} color="text-primary" />
          <ModalContent className={modalContent} data-qa="product-returns-new-modal-content">
            <div className={refundInfoText}>
              <Typography variant="m" size="body_long" color="text-primary" data-qa="store-return-text">
                {t('product-returns.modal.part1', { brand: storeBrandName })}
              </Typography>
              <Typography variant="m" size="body_long" color="text-primary">
                {t('product-returns.modal.part2')}
              </Typography>
            </div>
            <div className={easyRefundAdvantagesContainer}>
              <div className={easyRefundAdvantage}>
                <LemanaProLogoSimpleIcon size="xxl" strokeWidth={1} />
                <div className={easyRefundAdvantageText}>
                  <Typography variant="m" size="body_accent" color="text-primary">
                    {t('product-returns.modal.part3')}
                  </Typography>
                  <Typography variant="s" size="body_long" color="text-primary">
                    {t('product-returns.modal.part4', { brand: storeBrandName })}
                  </Typography>
                </div>
              </div>
              <div className={easyRefundAdvantage}>
                <CheckSquareOffsetIcon size="xxl" strokeWidth={1} />
                <div className={easyRefundAdvantageText}>
                  <Typography variant="m" size="body_accent" color="text-primary">
                    {t('product-returns.modal.part5')}
                  </Typography>
                  <Typography variant="s" size="body_long" color="text-primary">
                    {t('product-returns.modal.part6')}
                  </Typography>
                </div>
              </div>
              <div className={easyRefundAdvantage}>
                <ArrowBendDoubleUpLeftIcon size="xxl" strokeWidth={1} />
                <div className={easyRefundAdvantageText}>
                  <Typography variant="m" size="body_accent" color="text-primary">
                    {t('product-returns.modal.part7')}
                  </Typography>
                  <Typography variant="s" size="body_long" color="text-primary">
                    {t('product-returns.modal.part8')}
                  </Typography>
                </div>
              </div>
            </div>
          </ModalContent>
        </Modal>
      </Portal>
    </div>
  );
};
